<template>
   <router-view></router-view>

</template>

<script>

// import InBanner from './components/Index/InBanner.vue';
export default {
components:{
   // InBanner
},

}
</script>

